module.exports = __webpack_public_path__ + "img/ic_main_profile.4e284292.png";